import connectTooltip from "~/ui/Tooltip/connectTooltip";
import Tooltip from "~/components/Tooltip/Tooltip";

export default connectTooltip(Tooltip);